<template>
  <div>
    <div class="primary--text font-weight-bold ml-5">
      Historique des interventions
    </div>
    <div>
      <a style="float: right" @click="clearFilters">
        Vider les filtres
      </a>

      <div class="d-flex flex-wrap">
        <div class="ma-2">
          <filter-by-date type="date" small namespace="requests/history" />
        </div>
        <checkable-button
          label="Maintenance"
          :value="nature.includes('MAINTENANCE')"
          @input="handleNatureChange($event, 'MAINTENANCE')"
          class="ma-2 caption"
        />
        <checkable-button
          label="Travaux"
          :value="nature.includes('TRAVAUX')"
          @input="handleNatureChange($event, 'TRAVAUX')"
          class="ma-2 caption"
        />
        <checkable-button
          label="DI"
          :value="nature.includes('DI')"
          @input="handleNatureChange($event, 'DI')"
          class="ma-2 caption"
        />
        <checkable-button
          label="INO"
          :value="nature.includes('INO')"
          @input="handleNatureChange($event, 'INO')"
          class="ma-2 caption"
        />
      </div>
      <div
        :style="
          `background-color: ${
            darkThemeEnabled ? 'slategray' : 'azure'
          }; border-radius: 3vh`
        "
        class="d-flex flex-wrap"
      >
        <service-autocomplete
          label="Symptomes"
          class="ma-2 caption"
          multiple
          idField="code"
          dense
          outlined
          hide-details
          :disabled="!nature.includes('DI')"
          v-model="symptomTypeCode"
          item-text="name"
          item-value="code"
          :use-entities="false"
          :search-attributes-array="['name']"
          :url="typesUrl"
        />
        <service-autocomplete
          multiple
          idField="code"
          v-model="symptomQualifCode"
          :search-attributes-array="['name']"
          dense
          outlined
          hide-details
          :disabled="!nature.includes('DI')"
          label="Qualifications"
          class="ma-2 caption"
          item-text="name"
          item-value="code"
          :use-entities="false"
          :url="qualifsUrl"
          :baseAndQueryParams="symptomTypeCode | qualifParams"
        />
        <service-autocomplete
          multiple
          id-field="diagnostic_qualif_id"
          v-model="reason_id"
          :search-attributes-array="['diagnostic_qualif_name']"
          dense
          outlined
          hide-details
          :disabled="!nature.includes('DI')"
          label="Motif"
          class="ma-2 caption"
          item-text="diagnostic_qualif_name"
          nameField="diagnostic_qualif_name"
          item-value="diagnostic_qualif_id"
          :url="reasonsUrl"
          :use-entities="false"
        />
        <v-text-field
          placeholder="Appelant"
          class="ma-2 caption"
          :disabled="!nature.includes('DI')"
          dense
          outlined
          v-model="searchCustomer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FilterByDate from '@/components/boilerplate/RightSideBar/FilterByDate';
import Maths from '@/business/utils/maths';
import ServiceAutocomplete from '@/components/selects/ServiceAutocomplete';
import CheckableButton from '@/components/selects/CheckableButton';

export default {
  name: 'HistoryFilter',
  components: {
    CheckableButton,
    FilterByDate,
    ServiceAutocomplete,
  },
  computed: {
    ...mapGetters({
      darkThemeEnabled: 'boilerplate/darkThemeEnabled',
      qualifications: 'requests/history/qualifications/items',
      types: 'requests/history/types/items',
      attributesObj: 'requests/history/attributesObj',
    }),
    propertyId() {
      return this.$store.getters['requests/active'].property_id;
    },
    typesUrl() {
      return `${process.env.P2C_BASE_URI}/properties/${this.propertyId}/work_order_group_types`;
    },
    qualifsUrl() {
      return `${process.env.P2C_BASE_URI}/properties/${this.propertyId}/work_order_group_qualifications`;
    },
    reasonsUrl() {
      return `${process.env.P2C_BASE_URI}/diagnostic_qualifications`;
    },
    nature() {
      return this.attributesObj.nature.values;
    },
    symptomTypeCode: {
      get() {
        return this.attributesObj.work_order_group_type_code.values;
      },
      set(values) {
        this.setFilterAttributeHistory({
          attribute: 'work_order_group_type_code',
          values,
        });
        this.setFilterAttributeSymptomQualif({
          attribute: 'work_order_group_type_code',
          values,
        });
      },
    },
    symptomQualifCode: {
      get() {
        return this.attributesObj.work_order_group_qualif_code.values;
      },
      set(values) {
        this.setFilterAttributeHistory({
          attribute: 'work_order_group_qualif_code',
          values,
        });
      },
    },
    reason_id: {
      get() {
        return this.attributesObj.reason_id.values;
      },
      set(values) {
        this.setFilterAttributeHistory({
          attribute: 'reason_id',
          values,
        });
      },
    },
    searchCustomer: {
      get() {
        const { values } = this.attributesObj.customer_name;
        return values.length ? values[0] : null;
      },
      set(value) {
        this.setFilterAttributeHistory({
          attribute: 'customer_name',
          values: value.length ? [value] : [],
        });
      },
    },
  },
  filters: {
    qualifParams(ids) {
      return [
        {
          $or: ids.map((id) => ({ work_order_group_type_code: { $eq: id } })),
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      setFilterAttributeHistory: 'requests/history/setFilterAttribute',
      setFilterAttributeSymptomQualif:
        'requests/history/qualifications/setFilterAttribute',
      clearFilters: 'requests/history/clearFilters',
    }),
    handleNatureChange(event, nature) {
      const newNatures = this.nature.slice();
      if (event) {
        newNatures.push(nature);
        this.setFilterAttributeHistory({
          attribute: 'nature',
          values: newNatures,
        });
      } else {
        this.setFilterAttributeHistory({
          attribute: 'nature',
          values: Maths.arrayRemoveValues(newNatures, nature),
        });
      }
    },
  },
};
</script>
